import { render, staticRenderFns } from "./ReserveFromAppForm.vue?vue&type=template&id=1aaf6d1e&"
import script from "./ReserveFromAppForm.vue?vue&type=script&lang=js&"
export * from "./ReserveFromAppForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports